import type { BookingAddress, BookingStoreCar } from 'noddi-types';
import { useBookingActions } from 'noddi-web';
import { useNavigate } from 'react-router-dom';
import { useStationaryBookingActions } from '../stores/StationaryBookingStore';
import { useNewBookingPath } from './useNewBookingPath';

type BookingSeed = {
  /** Dropped into the cart before the flow opens. Only the home-delivery flow keeps them: picking a
   * service center clears the stationary car, so there the customer picks it again from the list. */
  cars?: BookingStoreCar[];
  address?: BookingAddress;
};

/** Drops the home-delivery draft and the service-center draft. Link buttons call this, then navigate themselves. */
export const useClearBookingDrafts = () => {
  const { clearStore } = useBookingActions();
  const { clearStore: clearStationaryBookingStore } = useStationaryBookingActions();

  return () => {
    clearStore();
    clearStationaryBookingStore();
  };
};

/** Clears both drafts, applies an optional home-delivery seed, and opens the new-booking path. */
export const useStartNewBooking = () => {
  const clearBookingDrafts = useClearBookingDrafts();
  const { addCar, setSelectedAddress } = useBookingActions();
  const { path: newBookingPath } = useNewBookingPath();
  const navigate = useNavigate();

  return (seed?: BookingSeed) => {
    clearBookingDrafts();
    if (seed?.address) {
      setSelectedAddress(seed.address);
    }
    seed?.cars?.forEach(addCar);
    void navigate(newBookingPath);
  };
};
